// extracted by mini-css-extract-plugin
export var actions = "MigrateToIOMLicenceModal-module--actions--c16bb";
export var blue = "#0eb3f2";
export var body = "MigrateToIOMLicenceModal-module--body--820b7";
export var emphasis = "MigrateToIOMLicenceModal-module--emphasis--0d54a";
export var flexEnd = "MigrateToIOMLicenceModal-module--flexEnd--88371";
export var flexFill = "MigrateToIOMLicenceModal-module--flexFill--aa271";
export var green = "#57d33b";
export var greenLink = "MigrateToIOMLicenceModal-module--green-link--c0cee";
export var grey = "var(--tone-mid)";
export var infoText = "MigrateToIOMLicenceModal-module--infoText--bccdf";
export var label = "MigrateToIOMLicenceModal-module--label--ae1f7";
export var modal = "MigrateToIOMLicenceModal-module--modal--500d3";
export var modalContent = "MigrateToIOMLicenceModal-module--modalContent--266b0";
export var notchGap = "32px";
export var orange = "#f8662b";
export var red = "#ff2741";
export var scrollArea = "MigrateToIOMLicenceModal-module--scrollArea--0f253";
export var submitButton = "MigrateToIOMLicenceModal-module--submitButton--b8e63";
export var viewport = "MigrateToIOMLicenceModal-module--viewport--1d519";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";